import { DocumentViewer, ProviderDocumentUrl, ProviderSendFax, renderDate, Spinner } from '@enter/core';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { RootStore } from 'stores';
import * as S from './claim-timeline-table.styles';

interface ISendFaxDetailProps {
    sendFax: ProviderSendFax;
}

export const SendFaxDetail: React.FunctionComponent<ISendFaxDetailProps> = inject('rootStore')(
    observer(
        (props: ISendFaxDetailProps): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const { claimStore } = rootStore;
            const { sendFax } = props;
            const [loading, setLoading] = useState(false);
            const [documentUrl, setDocumentUrl] = useState<ProviderDocumentUrl | undefined>();
            useEffect(() => {
                (async (): Promise<void> => {
                    if (sendFax?.id && sendFax.document?.id) {
                        setLoading(true);
                        const url = await claimStore.viewFaxById(sendFax.id);

                        setDocumentUrl(url);
                        setLoading(false);
                    }
                })();
            }, [sendFax, claimStore]);
            return (
                <>
                    {loading ? (
                        <Spinner />
                    ) : (
                        <S.ExpandCol>
                            {documentUrl?.url && <DocumentViewer url={documentUrl.url} />}
                            <S.ExpandTable key={sendFax.id} expand={true}>
                                <S.ExpandTBody>
                                    {!loading && (
                                        <>
                                            <S.ExpandTR>
                                                <S.ExpandTH>To</S.ExpandTH>
                                                <S.ExpandTD>{sendFax.toE164}</S.ExpandTD>
                                            </S.ExpandTR>
                                            <S.ExpandTR>
                                                <S.ExpandTH># of Pages</S.ExpandTH>
                                                <S.ExpandTD>{sendFax.pages}</S.ExpandTD>
                                            </S.ExpandTR>
                                            <S.ExpandTR>
                                                <S.ExpandTH>Attempts</S.ExpandTH>
                                                <S.ExpandTD>{sendFax.attempts}</S.ExpandTD>
                                            </S.ExpandTR>
                                            <S.ExpandTR>
                                                <S.ExpandTH>Sent</S.ExpandTH>
                                                <S.ExpandTD>{renderDate(sendFax.sent)}</S.ExpandTD>
                                            </S.ExpandTR>
                                        </>
                                    )}
                                </S.ExpandTBody>
                            </S.ExpandTable>
                        </S.ExpandCol>
                    )}
                </>
            );
        },
    ),
);
